import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

const footerLinks = {
  快速导航: [
    { label: '首页', to: '/' },
    { label: '分类浏览', to: '/categories' },
    { label: '关于我们', to: '/about' },
    { label: '最新活动', to: '/about' },
  ],
  热门分类: [
    { label: '手工DIY', to: '/category/shougong' },
    { label: '摄影艺术', to: '/category/sheying' },
    { label: '美食烹饪', to: '/category/meishi' },
    { label: '游戏电竞', to: '/category/youxi' },
  ],
  关于我们: [
    { label: '品牌介绍', to: '/about' },
    { label: '用户口碑', to: '/about' },
    { label: '联系方式', to: '/about' },
    { label: '常见问题', to: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl text-white hover:text-primary-300 transition-colors">
              {siteConfig.name}
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              {siteConfig.tagline}
            </p>
            <p className="mt-4 text-xs text-background-500">
              发现热爱，连接同好。加入撸撸社，开启你的兴趣之旅。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-background-500 hover:text-primary-300 transition-colors text-xs whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-background-500 hover:text-primary-300 transition-colors text-xs whitespace-nowrap">服务条款</a>
              <a href="#" className="text-background-500 hover:text-primary-300 transition-colors text-xs whitespace-nowrap">社区规范</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}